module.exports = __webpack_public_path__ + "img/block_chain_banner.3099b1e5.png";